document.addEventListener('DOMContentLoaded', function() {
    const wheel = document.querySelector('.wheel .wheel-inner');
    const items = 6;
    const diameter = wheel.offsetHeight;
    const radius = diameter / 2;
    const angle = 360 / items;
    const height = (2 * Math.PI * radius) / items + 9;

    // Sélectionner les segments existants et les configurer
    const segments = wheel.querySelectorAll('.wheel-segment');
    segments.forEach((segment, i) => {
        const transform = `translateY(-50%) rotateX(${angle * i}deg) translateZ(${radius}px)`;
        segment.style.transform = transform;
        segment.style.height = `${height}px`;
    });

    // Sélectionner spécifiquement le bouton "Je veux ma reco"
    const spinButton = document.querySelector('.js-spin');
    let isSpinning = false;
    let animationInterval;

    // Modifier la position initiale
    wheel.style.transform = 'rotateX(0deg)';
    wheel.offsetHeight; // Force reflow

    function startInitialAnimation() {
        wheel.style.transition = 'transform 10s linear';
        wheel.style.transform = 'rotateX(-360deg)';

        animationInterval = setInterval(() => {
            wheel.style.transition = 'none';
            wheel.style.transform = 'rotateX(0deg)';
            wheel.offsetHeight; // Force reflow
            wheel.style.transition = 'transform 10s linear';
            wheel.style.transform = 'rotateX(-360deg)';
        }, 10000);
    }

    // Démarrer l'animation initiale après l'overlay
    const overlay = document.querySelector('.Overlay');
    if (overlay) {
        overlay.addEventListener('click', () => {
            const introVideo = document.getElementById('introVideo');
            if (introVideo) {
                introVideo.addEventListener('ended', startInitialAnimation);
            } else {
                startInitialAnimation();
            }
        });
    } else {
        startInitialAnimation();
    }

    // Au début du fichier, après la déclaration des variables initiales
    const seenRecos = new Set(
        JSON.parse(localStorage.getItem('voeux2025_seen_recos') || '[]')
    );

    spinButton.addEventListener('click', function() {
        if (isSpinning) return;

        clearInterval(animationInterval); // Arrêter l'animation continue

        const currentRotation = parseFloat(getComputedStyle(wheel).transform.split(',')[5]) || 0;
        isSpinning = true;

        // Fonction pour trouver une recommandation non vue
        const findUnseenReco = () => {
            const categories = Object.keys(recos);
            const availableRecos = [];

            // Collecter toutes les recommandations non vues
            categories.forEach(category => {
                recos[category].forEach(reco => {
                    if (!seenRecos.has(reco.link)) {
                        availableRecos.push({
                            category,
                            reco
                        });
                    }
                });
            });

            // Si toutes les recommandations ont été vues, réinitialiser
            if (availableRecos.length === 0) {
                seenRecos.clear();
                localStorage.removeItem('voeux2025_seen_recos');
                return findUnseenReco();
            }

            // Sélectionner une recommandation aléatoire parmi celles disponibles
            const randomChoice = availableRecos[Math.floor(Math.random() * availableRecos.length)];
            return randomChoice;
        };

        const chosenReco = findUnseenReco();
        const randomCategory = chosenReco.category;
        const randomReco = chosenReco.reco;

        // Marquer la recommandation comme vue
        seenRecos.add(randomReco.link);
        localStorage.setItem('voeux2025_seen_recos', JSON.stringify([...seenRecos]));

        const categoryIndexMap = {
            'podcasts': 0,
            'films': 1,
            'bouquins': 2,
            'art': 3,
            'design': 4,
            'web': 5
        };
        const randomSegment = categoryIndexMap[randomCategory];

        const randomRotations = 5 + Math.floor(Math.random() * 3);
        const segmentAngle = angle * randomSegment;
        const totalDegrees = currentRotation - ((randomRotations * 360) + segmentAngle);

        wheel.style.transition = 'transform 10s cubic-bezier(0.2, 0.1, 0.1, 1)';
        wheel.style.transform = `rotateX(${totalDegrees}deg)`;

        setTimeout(() => {
            isSpinning = false;
            wheel.style.transition = 'none';
            wheel.style.transform = `rotateX(${totalDegrees}deg)`;

            const selectedSegment = segments[randomSegment];
            const segmentImage = selectedSegment.querySelector('img');
            const segmentTitle = selectedSegment.querySelector('.wheel-title');

            segmentImage.style.opacity = '0.33';
            segmentTitle.style.opacity = '1';

            selectedSegment.innerHTML += `
                <div class="wheel-number left blink">#${randomReco.number}</div>
                <div class="wheel-number right blink">#${randomReco.number}</div>
            `;

            setTimeout(() => {
                const numbers = selectedSegment.querySelectorAll('.wheel-number');
                numbers.forEach(number => number.classList.remove('blink'));

                window.location.href = randomReco.link;
            }, 2500);
        }, 10000);
    });

    function calculateHeight(radius, items, isMobile) {
        const padding = isMobile ? 7 : 9;
        return (2 * Math.PI * radius) / items + padding;
    }

    function updateWheelDimensions() {
        const isMobile = window.innerWidth <= 768;
        const diameter = wheel.offsetHeight;
        const radius = diameter / 2;
        const newHeight = calculateHeight(radius, items, isMobile);

        segments.forEach((segment, i) => {
            const transform = `translateY(-50%) rotateX(${angle * i}deg) translateZ(${radius}px)`;
            segment.style.transform = transform;
            segment.style.height = `${newHeight}px`;
        });
    }

    // Ajouter l'écouteur pour le redimensionnement
    window.addEventListener('resize', updateWheelDimensions);

    // Appeler updateWheelDimensions au lieu du code original de configuration des segments
    updateWheelDimensions();
});